const sizes = [
    {
        width: 210,
        height: 297,
        name: 'A4',
        price: '24,95',
        isActive: false,
        material: 'poster'
    },
    {
        width: 297,
        height: 420,
        name: 'A3',
        price: '29,95',
        isActive: false,
        material: 'poster'
    },
    {
        width: 420,
        height: 594,
        name: 'A2',
        price: '34,95',
        isActive: true,
        material: 'poster'
    },
    {
        width: 594,
        height: 841,
        name: 'A1',
        price: '39,95',
        isActive: false,
        material: 'poster'
    },
    {
        width: 841,
        height: 1189,
        name: 'A0',
        price: '44,95',
        isActive: false,
        material: 'poster'
    },
    {
        width: 300,
        height: 400,
        name: '30x40',
        price: '49,95',
        isActive: false,
        material: 'forex'
    },
    {
        width: 500,
        height: 700,
        name: '50x70',
        price: '69,95',
        isActive: false,
        material: 'forex'
    },
    {
        width: 600,
        height: 900,
        name: '60x90',
        price: '79,95',
        isActive: false,
        material: 'forex'
    },
    {
        width: 300,
        height: 400,
        name: '30x40',
        price: '64,95',
        isActive: false,
        material: 'dibond'
    },
    {
        width: 500,
        height: 700,
        name: '50x70',
        price: '79,95',
        isActive: false,
        material: 'dibond'
    },
    {
        width: 600,
        height: 900,
        name: '60x90',
        price: '129,95',
        isActive: false,
        material: 'dibond'
    },
    {
        width: 240,
        height: 360,
        name: '252',
        displayName: 'Makkelijk',
        price: '29,95',
        isActive: false,
        material: 'puzzle',
        overlay: '/img/editor/puzzle-252.png'
    },
    {
        width: 300,
        height: 430,
        name: '315',
        displayName: 'Gemiddeld',
        price: '33,95',
        isActive: false,
        material: 'puzzle',
        overlay: '/img/editor/puzzle-315.png'
    },
    {
        width: 400,
        height: 540,
        name: '500',
        displayName: 'Moeilijk',
        price: '36,95',
        isActive: false,
        material: 'puzzle',
        overlay: '/img/editor/puzzle-500.png'
    },
    {
        width: 440,
        height: 680,
        name: '1000',
        displayName: 'Heel Moeilijk',
        price: '39,95',
        isActive: false,
        material: 'puzzle',
        overlay: '/img/editor/puzzle-1000.png'
    },
];

export default sizes;